export { default as DocumentDownloadOutlineIcon } from './DocumentDownloadOutlineIcon';
